
import MyFavoritesToggle from '@dashboard/my-favorites'
import RatingInfo from '@internal-reviews/components/RatingInfo'

import EcoBlockAnchor from '../EcoBlockAnchor'
import Gallery from '../Gallery'
import Model from '../Model'

export default {
  components: {
    EcoBlockAnchor,
    Gallery,
    Model,
    MyFavoritesToggle,
    RatingInfo,
  },

  props: {
    reassurance: {
      type: Object,
      required: true,
    },

    ratings: {
      type: Object,
      required: true,
    },

    images: {
      type: Array,
      required: true,
    },

    page: {
      type: Object,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    modelTitle: {
      type: String,
      required: true,
    },

    modelSubtitles: {
      type: Array,
      required: true,
    },

    shouldDisplayEcoBlock: {
      type: Boolean,
      required: true,
    },

    trackingInfo: {
      type: Object,
      default: () => ({}),
    },

    activeGrade: {
      type: Object,
      required: true,
    },
  },
}
